// extracted by mini-css-extract-plugin
module.exports = {"box":"EditorHeader_box_2rGn-","headerMenu":"EditorHeader_headerMenu_2_tVx","selectPlatform":"EditorHeader_selectPlatform_3nL83"};